import { axiosWrapper } from "../../axiosWrapper";

export class GlobalSearch {
  public static getEnhancedSearchResult(searchText?: string) {
    return axiosWrapper.Get(`CustomerAccount/EnhancedSearch/${searchText}`);
  }
}
